import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import BaseModal from "./BaseModal";

export default function SimpleResultModal({ variant, onClose, messageKey, titleKey }) {
  const { t } = useTranslation();
  const isSuccess = variant === "success";

  return (
    <BaseModal
      title={t(titleKey || (isSuccess ? "common.success" : "common.error"))}
      onClose={onClose}
      maxWidthClass="max-w-sm"
    >
      <div className="space-y-8 py-4">
        <div className="flex flex-col items-center text-center gap-6">
          <motion.div
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: "spring", damping: 15, stiffness: 200 }}
            className={`h-24 w-24 rounded-[32px] flex items-center justify-center shadow-2xl ${
              isSuccess 
                ? "bg-emerald-50 dark:bg-emerald-900/20 text-[#1e9f6b] shadow-[#1e9f6b]/20" 
                : "bg-red-50 dark:bg-red-900/20 text-red-600 shadow-red-500/20"
            }`}
          >
            <span className="material-symbols-outlined text-[48px]">
              {isSuccess ? "check_circle" : "error"}
            </span>
          </motion.div>
          
          <div className="space-y-2">
            <h4 className="text-xl font-black text-slate-900 dark:text-white italic uppercase tracking-tight">
              {t(titleKey || (isSuccess ? "common.success" : "common.error"))}
            </h4>
            <p className="text-sm font-bold text-slate-500 dark:text-slate-400 leading-relaxed px-4">
              {t(messageKey)}
            </p>
          </div>
        </div>

        <button
          type="button"
          onClick={onClose}
          className={`w-full h-14 rounded-2xl font-black text-sm uppercase tracking-[0.2em] transition-all active:scale-[0.98] shadow-xl ${
            isSuccess 
              ? "bg-[#1e9f6b] hover:bg-[#0d7a52] text-white shadow-[#1e9f6b]/30" 
              : "bg-red-600 hover:bg-red-700 text-white shadow-red-500/30"
          }`}
        >
          {t("common.close")}
        </button>
      </div>
    </BaseModal>
  );
}


